export const getQueryString = (): string => {
  let queryString = '';

  if (typeof window !== 'undefined') {
    queryString = window.location.search;
  }

  return queryString;
};
